export function getDefaultByokAddonConfig() {
  return {
    actuator: {
      minCpu: "50m",
      maxCpu: "8001m",
      minMemory: "200Mi",
      maxMemory: "8000Mi",
      logLevel: "info",
      env: {
        CACHE_PERIOD_DATA_SERVICE: "600",
        LABEL_NODES: "false",
      },
    },
    middlebox: {
      enabled: false,
      bandwidthAlertMbps: 650,
    },
    juicefs: {
      enabled: false,
    },
    common: {
      deploymentReplicas: 1,
      pdb: {
        maxUnavailable: 1,
      },
    },
    longhorn: {
      numberOfReplicas: 2,
    },
    byok: {
      noDefaultStorageClasses: false,
    },
    ingress: {
      cpu: "50m",
      memory: "200Mi",
      targetPercent: 6000, // target is 3000m so 50m * 6000% = 3000m
    },
    istio: {
      istiod: {
        replicas: 2,
        minCpu: "50m",
        maxCpu: "8001m",
        minMemory: "100Mi",
        maxMemory: "8000Mi",
        pdb: 0,
      },
      ingressgateway: {
        replicas: 2,
        maxCpu: "1",
        maxMemory: "1Gi",
      },
      sidecar: {
        minCpu: "0m",
        minMemory: "200Mi",
      },
    },
    logSplitter: {
      minCpu: "1m",
      maxCpu: "1000m",
      minMemory: "10Mi",
      maxMemory: "2000Mi",
      memBufferSize: "128M", // Mem_Buf_Limit for fluentbit
      perPodRate: 10000, // low value on purpose so we can see status message more often
    },
    monitoring: {
      minMemory: "100Mi",
      maxMemory: "20Gi",
      kubeStateMetrics: {
        minMemory: "25Mi",
      },
      prometheus: {
        main: {
          storage: "10Gi",
        },
      },
      remoteWrite: [],
      externalLabels: {},
    },
    redis: {
      minCpu: "10m",
      maxCpu: "2001m",
      minMemory: "100Mi",
      maxMemory: "1000Mi",
      storage: "8Gi",
    },
    redisHa: {
      minCpu: "50m",
      maxCpu: "2001m",
      minMemory: "100Mi",
      maxMemory: "1000Mi",
      storage: 0,
    },
    redisSentinel: {
      minCpu: "10m",
      maxCpu: "500m",
      minMemory: "10Mi",
      maxMemory: "400Mi",
      storage: 0,
    },
    tempoAgent: {
      minCpu: "0m",
      minMemory: "10Mi",
    },
  };
}
